(function (angular) {
    'use strict';

    var MemoryConversationStore = (function () {
        function MemoryConversationStore($rootScope, $q, jwtService, badgeService) {
            this.conversations = [];
            this.messageStore = {};
            this.$rootScope = $rootScope;
            this.$q = $q;
            this.jwtService = jwtService;
            this.badgeService = badgeService;
            this.callbacks = [];

            this._synchronising = false;
            // cache this and only broadcast when it changes to prevent loads of unnecessary digest loops
            this._newMessageCount = 0;
        }

        MemoryConversationStore.prototype.addEventListener = function (callback) {
            if (this.callbacks.indexOf(callback) === -1) {
                this.callbacks.push(callback);
            }
        };

        MemoryConversationStore.prototype.removeEventListener = function (callback) {
            var index = this.callbacks.indexOf(callback);

            if (index !== -1) {
                this.callbacks.splice(index, 1);
            }
        };

        MemoryConversationStore.prototype.publishEvent = function (eventName, data) {
            this.callbacks.forEach(function (callback) {
                callback(eventName, data);
            });
        };

        MemoryConversationStore.prototype.setApiSpace = function (apiSpace) {
            this.apiSpace = apiSpace;
        }

        MemoryConversationStore.prototype.reset = function () {
            this.conversations = [];
            this.messageStore = {};
            this._newMessageCount = 0;
            this.badgeService.setCount(0);
            return this.$q.resolve(true);
        };

        /**
         * 
         */
        MemoryConversationStore.prototype.updateNewMessageCount = function () {
            var _this = this;
            // get a count of conversations with status of new 
            var newMessageCount = _this.conversations.reduce(function (sum, conversation) {

                if (("PLATFORMUSER\\" + _this.jwtService.payload.sub) === conversation.allocatedTo) {
                    return sum + (conversation.status === "new" ? 1 : 0);
                } else {
                    return sum;
                }

            }, 0);

            // only broadcast if changed 🤷‍♂️
            if (_this._newMessageCount !== newMessageCount) {
                _this._newMessageCount = newMessageCount;
                _this.badgeService.setCount(newMessageCount);
            }
        }

        // going to return a copy of this object rather than a reference
        // as we want to be able to detect changes 
        MemoryConversationStore.prototype.getConversation = function (conversationId) {
            var _this = this;
            return this.$q(function (resolve, reject) {
                var found = _this._findConversation(conversationId);
                var copy = found ? angular.copy(found) : null;
                resolve(copy);
            });
        };

        /**
         * Find the agent participant or fallback to the teamId and assign to allocatedTo property
         * 
         * @param {*} conversation 
         */
        MemoryConversationStore.prototype.getAllocatedTo = function (conversation) {

            var allocatedTo = "";

            angular.forEach(conversation.participants, function (participant) {
                if (participant.role === "agent") {
                    allocatedTo = participant.id;//.replace("PLATFORMUSER\\", "");
                }
            });

            if (allocatedTo === "") {
                if (conversation.teamId && conversation.teamId !== "") {
                    allocatedTo = conversation.teamId;
                } else {
                    allocatedTo = "Nobody";
                }
            }

            return allocatedTo;
        }

        Object.defineProperty(MemoryConversationStore.prototype, "synchronising", {
            get: function () {
                return this._synchronising;
            },
            set: function (synchronising) {
                this._synchronising = synchronising;
            },
            enumerable: true,
            configurable: true
        });

        Object.defineProperty(MemoryConversationStore.prototype, "chats", {
            get: function () {
                return this.conversations;
            },
            enumerable: true,
            configurable: true
        });

        Object.defineProperty(MemoryConversationStore.prototype, "newMessageCount", {
            get: function () {
                return this._newMessageCount;
            },
            enumerable: true,
            configurable: true
        });

        MemoryConversationStore.prototype.createConversation = function (conversation) {
            var _this = this;
            return this.$q(function (resolve, reject) {
                if (_this._indexOfConversation(conversation.id) === -1) {

                    var allocatedTo = _this.getAllocatedTo(conversation);
                    conversation.allocatedTo = allocatedTo;

                    conversation.participantAvatar = "./assets/img/avatar.svg";
                    conversation.participantName = "";

                    _this.conversations.push(conversation);
                    _this.messageStore[conversation.id] = [];

                    resolve(true);

                    _this.updateNewMessageCount();

                    if (!_this._synchronising) {
                        _this.$rootScope.$broadcast("MemoryConversationStore.conversationCreated", conversation);
                        _this.publishEvent("MemoryConversationStore.conversationCreated", conversation);
                    }
                }
                else {
                    reject({ message: "Conversation " + conversation.id + " already exists" });
                }
            });
        };

        MemoryConversationStore.prototype.updateConversation = function (conversation) {
            var _this = this;
            return this.$q(function (resolve, reject) {
                var found = _this._findConversation(conversation.id);
                if (found) {
                    // has status changed ?
                    var statusChanged = found.status !== conversation.status;

                    found.name = conversation.name;
                    found.description = conversation.description;
                    found.roles = conversation.roles;
                    found.isPublic = conversation.isPublic;
                    found.earliestLocalEventId = conversation.earliestLocalEventId;
                    found.latestLocalEventId = conversation.latestLocalEventId;
                    found.continuationToken = conversation.continuationToken;

                    // Portal Chat specific 
                    found.teamId = conversation.teamId;
                    found.channelId = conversation.channelId;
                    found.status = conversation.status;
                    found.participants = conversation.participants;

                    var allocatedTo = _this.getAllocatedTo(found);

                    var allocationChanged = conversation.allocatedTo !== allocatedTo;
                    found.allocatedTo = allocatedTo;
                    if (statusChanged || allocationChanged) {
                        _this.$rootScope.$broadcast("MemoryConversationStore.statusUpdate", found);

                        var event = {
                            statusChanged: statusChanged,
                            allocationChanged: allocationChanged,
                            conversation: found
                        }

                        _this.publishEvent("MemoryConversationStore.statusUpdate", event);
                    }

                    resolve(true);

                    _this.updateNewMessageCount();
                }
                else {
                    reject({ message: "Conversation " + conversation.id + " not found" });
                }
            });
        };
        MemoryConversationStore.prototype.deleteConversation = function (conversationId) {
            var _this = this;
            return this.$q(function (resolve, reject) {
                var index = _this._indexOfConversation(conversationId);
                var deleted = _this.conversations[index];
                if (index >= 0) {
                    _this.conversations.splice(index, 1);
                    resolve(true);

                    if (!_this._synchronising) {
                        _this.$rootScope.$broadcast("MemoryConversationStore.deleteConversation", conversationId);

                        _this.publishEvent("MemoryConversationStore.deleteConversation", deleted);
                    }
                    _this.updateNewMessageCount();
                }
                else {
                    reject({ message: "Conversation " + conversationId + " not found" });
                }
            });
        };
        MemoryConversationStore.prototype.getMessage = function (conversationId, messageId) {
            var _this = this;
            return this.$q(function (resolve, reject) {
                resolve(_this._findMessage(conversationId, messageId));
            });
        };

        MemoryConversationStore.prototype.updateMessage = function (conversationId, messageId, parts) {
            var _this = this;
            return this.$q(function (resolve, reject) {
                var message = _this._findMessage(conversationId, messageId);
                if (message) {
                    message.parts = parts;
                    resolve(message);
                } else {
                    resolve(false);
                }

            });
        };

        MemoryConversationStore.prototype.updateMessageStatus = function (conversationId, messageId, profileId, status, timestamp) {
            var _this = this;
            return this.$q(function (resolve, reject) {
                var message = _this._findMessage(conversationId, messageId);
                if (message) {
                    if (message.statusUpdates &&
                        message.statusUpdates[profileId] &&
                        message.statusUpdates[profileId].status === "read") {
                        resolve(false);
                    }
                    else {
                        if (!message.statusUpdates) {
                            message.statusUpdates = {};
                        }
                        message.statusUpdates[profileId] = {
                            status: status,
                            on: timestamp
                        };
                        resolve(true);
                    }
                }
                else {
                    reject({ message: "Message " + messageId + " not found in conversation " + conversationId });
                }
            });
        };
        /**
         * Enhance this implementation to maintain the newest message on the conversation entity
         * 
         */
        MemoryConversationStore.prototype.createMessage = function (message) {
            var _this = this;
            return this.$q(function (resolve, reject) {
                var found = _this._findMessage(message.conversationId, message.id);
                if (found === null) {
                    var conversationMessages = _this.messageStore[message.conversationId];
                    if (conversationMessages) {
                        var position = 0;
                        for (var i = conversationMessages.length - 1; i >= 0; i--) {
                            var _message = conversationMessages[i];
                            if (_message.sentEventId < message.sentEventId) {
                                position = i + 1;
                                break;
                            }
                        }

                        // is this the newest message ? If so, add it to the conversation object
                        if (position === conversationMessages.length) {
                            var conversation = _this._findConversation(message.conversationId)
                            if (conversation) {
                                conversation.lastMessage = message;

                                // TODO: this logic needs to go into chat layer !!!
                                if (conversation.latestLocalEventId < message.sentEventId) {
                                    conversation.lastMessageTimestamp = message.sentOn;
                                }
                            }
                        }

                        conversationMessages.splice(position, 0, message);

                        // only send the message when not syncing so we dont bet bombarded when we switch views ...
                        if (!_this._synchronising) {
                            _this.$rootScope.$broadcast("MemoryConversationStore.createMessage", message);
                            _this.publishEvent("MemoryConversationStore.createMessage", message);
                        }

                        resolve(true);
                    }
                    else {
                        reject({ message: "Conversation " + message.conversationId + " not found in messageStore" });
                    }
                }
                else {
                    console.warn("Message already in store, updating ...", message);
                    found.sentEventId = message.sentEventId;
                    found.senderId = message.senderId;
                    found.sentOn = message.sentOn;
                    found.statusUpdates = message.statusUpdates;
                    resolve(false);
                }
            });
        };
        MemoryConversationStore.prototype.getConversations = function () {
            return this.$q.resolve(this.conversations);
        };
        MemoryConversationStore.prototype.getMessages = function (conversationId) {
            var conversationMessages = this.messageStore[conversationId];
            return this.$q.resolve(conversationMessages ? conversationMessages : []);
        };
        MemoryConversationStore.prototype.deleteConversationMessages = function (conversationId) {
            this.messageStore[conversationId] = [];
            return this.$q.resolve(true);
        };
        MemoryConversationStore.prototype._findConversation = function (conversationId) {
            var conversation = this.conversations.find((x) => { return x.id === conversationId; });
            return conversation ? conversation : null;
        };
        MemoryConversationStore.prototype._indexOfConversation = function (conversationId) {
            return this.conversations.findIndex((c) => { return c.id === conversationId });
        };
        MemoryConversationStore.prototype._findMessage = function (conversationId, messageId) {
            var conversationMessages = this.messageStore[conversationId];
            if (conversationMessages) {
                var message = conversationMessages.find((x) => { return x.id === messageId; });
                return message ? message : null;
            }
            else {
                return null;
            }
        };
        return MemoryConversationStore;
    }());

    angular.module('chat2')
        .factory('comapiChatStore', ["$rootScope", "$q", "jwtService", "badgeService", function ($rootScope, $q, jwtService, badgeService) {
            var store = new MemoryConversationStore($rootScope, $q, jwtService, badgeService);
            return store;
        }]);

})(window.angular);
